/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Lifecycle_Impact_ItemsInputs */

const en_lifecycle_impact_items = /** @type {(inputs: Lifecycle_Impact_ItemsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Items: ${i?.count}`)
};

const de_lifecycle_impact_items = /** @type {(inputs: Lifecycle_Impact_ItemsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vorgänge: ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Items: {count}" |
*
* @param {Lifecycle_Impact_ItemsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const lifecycle_impact_items = /** @type {((inputs: Lifecycle_Impact_ItemsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lifecycle_Impact_ItemsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_lifecycle_impact_items(inputs)
	return en_lifecycle_impact_items(inputs)
});